<template>
  <ValidationObserver ref="submitWorkersValidation">
    <DialogFull :data="dialogSettings" @close="close">
      <template v-slot:dialog.body>
        <SubmitWorkersForBooking
          :showValidationErrors="showValidationErrors"
          @onChange="setSelectedWorkers"
        />
      </template>
      <template v-slot:dialog.action>
        <PrimaryButton @click.native="onSubmit" :loading="isLoading">
          Submit Workers
        </PrimaryButton>
      </template>
    </DialogFull>
  </ValidationObserver>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import SubmitWorkersForBooking from "@/views/bookings/components/SubmitWorkers/components/SubmitWorkersForBooking";
import { ValidationObserver } from "vee-validate";
import { CREATE_APPLICATION } from "@/store/modules/applications/actions";
import { createNamespacedHelpers } from "vuex";
import { APPLICATION_NAMESPACE } from "@/store/modules/applications";
import { BOOKINGS_NAMESPACE } from "@/store/modules/bookings/actions";
import { map, size } from "lodash";
import { POST_GLOBAL_MESSAGE } from "@/store/modules/global/action-types";
import { mapActions } from "vuex";
import pluralize from "pluralize";

const { mapActions: mapApplicationActions } = createNamespacedHelpers(
  APPLICATION_NAMESPACE
);
const { mapState: mapBookingState } = createNamespacedHelpers(
  BOOKINGS_NAMESPACE
);

export default {
  name: "NewBooking",
  components: {
    PrimaryButton,
    DialogFull,
    SubmitWorkersForBooking,
    ValidationObserver
  },
  inject: ["currentBookingId"],
  data() {
    return {
      bookingData: {},
      isLoading: false,
      showValidationErrors: false,
      selectedWorkersIds: [],
      selectedApplicationsIds: []
    };
  },
  computed: {
    ...mapBookingState({
      currentBooking: state => state.currentBooking
    }),
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Submit Worker for Booking"
      };
    },
    utm_source() {
      return this.$route.query.utm_source;
    }
  },
  methods: {
    ...mapActions({
      postGlobalMessage: POST_GLOBAL_MESSAGE
    }),
    ...mapApplicationActions({
      createApplication: CREATE_APPLICATION
    }),
    async onSubmitWorkers() {
      const submitRequests = this.selectedWorkersIds.map(workerId =>
        this.createApplication({
          user: { id: workerId },
          booking: { id: this.currentBookingId },
          utm_source: this.utm_source
        })
      );
      const applicationsResponses = await Promise.all(submitRequests);
      this.selectedApplicationsIds = map(
        applicationsResponses,
        ({ data }) => data.id
      );
    },
    async onSubmit() {
      this.showValidationErrors = true;
      this.isLoading = true;
      await this.onSubmitWorkers();
      this.$emit("close");
      this.postSuccessMessage();
      this.isLoading = false;
      this.showValidationErrors = false;
    },
    postSuccessMessage() {
      const message = {
        snackbar: true,
        type: "success",
        title: `${pluralize(
          "Application",
          size(this.selectedApplicationsIds)
        )} created`
      };
      this.postGlobalMessage(message);
    },
    setSelectedWorkers(selectedWorkersIds) {
      this.selectedWorkersIds = selectedWorkersIds;
    },
    close() {
      this.$emit("close");
    }
  },
  props: {
    isOpen: Boolean
  }
};
</script>

<style lang="scss"></style>
